import { Box, styled } from '@mui/material';
import {
  approvalFormTableStyles,
  approvalSectionToggleStyles,
  approvalValueBoxStyles,
} from '@/components/Approval/@components/ApprovalFormTable';
import {
  APPROVAL_SECTION_GAP,
  infoSectionTitleStyles,
} from '@/components/Approval/@components/InfoSection';

/**
 * 저장 HTML 스냅샷(utils/approval/expensePreApprovalHtml) 의 클래스에 스타일을 입힘.
 * 표·값 박스·여닫기는 공통 양식 스타일과 같은 값 — 작성 화면과 모양을 맞춤
 */
export const ExpensePreApprovalSlotRoot = styled(Box)(({ theme }) => ({
  marginBottom: 24,
  '& .expense-section': { marginBottom: APPROVAL_SECTION_GAP },
  '& .expense-section-lg': { marginBottom: APPROVAL_SECTION_GAP },
  '& .expense-label': {
    display: 'block',
    marginBottom: 8,
    ...infoSectionTitleStyles,
  },
  '& .approval-value-box': approvalValueBoxStyles(false),
  '& .approval-value-box.is-filled': {
    backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  },
  '& .approval-form-table-scroll, & .expense-section-lg, & .expense-vendor-card':
    { overflowX: 'auto' },
  '& table.approval-form-table': approvalFormTableStyles(theme),
  '& .currency-label': { display: 'inline-flex', alignItems: 'center', gap: 5 },
  '& .currency-flag': {
    width: 20,
    height: 20,
    boxSizing: 'border-box',
    border: '1px solid var(--dk-line, #F3F5F7)',
    borderRadius: 2,
    backgroundColor: 'var(--dk-bg-subtle, #F3F5F7)',
    objectFit: 'contain',
  },
  '& .expense-payment-info': { marginBottom: APPROVAL_SECTION_GAP },
  '& summary.approval-section-toggle': {
    ...approvalSectionToggleStyles,
    listStyle: 'none',
    '&::-webkit-details-marker': { display: 'none' },
  },
  '& .toggle-icon': {
    display: 'inline-block',
    width: 12,
    height: 12,
    margin: '0 3px',
    backgroundColor: '#1A1A1A',
    mask: 'url(/icons/approval/chevron-down.svg) center / contain no-repeat',
    WebkitMask:
      'url(/icons/approval/chevron-down.svg) center / contain no-repeat',
  },
  '& details[open] .toggle-icon': {
    mask: 'url(/icons/approval/chevron-up.svg) center / contain no-repeat',
    WebkitMask:
      'url(/icons/approval/chevron-up.svg) center / contain no-repeat',
  },
  '& .expense-vendor-card': {
    marginBottom: 24,
    padding: 16,
    borderRadius: 2,
    backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  },
  '& .expense-field': { marginBottom: 15 },
  '& .expense-field-label': {
    display: 'block',
    marginBottom: 5,
    fontSize: 14,
    lineHeight: '20px',
    color: 'var(--dk-text, #1A1A1A)',
  },
}));
